import { Ambient, Directional } from "@objects/lights";
class LightManager {
    lights;
    static instance;
    /**
     * LightManager holds and controls all the lights.
     * @param scene the rendering scene.
     * @private
     */
    constructor(scene) {
        this.lights = [];
        this.lights.push(new Ambient(scene));
        this.lights.push(new Directional(scene));
    }
    static getInstance(scene) {
        if (!LightManager.instance)
            LightManager.instance = new LightManager(scene);
        return LightManager.instance;
    }
}
export default LightManager;
